import { BaseWebComponentDataProviderFactory } from '../../../../framework/BaseWebComponentDataProviderFactory';
import { EditLicensingOptionsMenuGzDataProvider } from '../dataProvider/EditLicensingOptionsMenuGzDataProvider';
import { API_TYPE_GZ } from '../../../../webcomponents.constants';

export class EditLicensingOptionsMenuDataProviderFactory extends BaseWebComponentDataProviderFactory {
  constructor() {
    super();
    this.map.set(API_TYPE_GZ, EditLicensingOptionsMenuGzDataProvider);
  }
}
